import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import { ButtonContainer, Container } from './styled';
import { MainActionsProps } from './types';

export const MainActions: FC<MainActionsProps> = ({
  onClickRegisterTrucker: handleClickRegisterTrucker,
  onClickTalkWithASpecialist: handleClickTalkWithASpecialist,
}) => (
  <Container>
    <FuelTypography size="heading-lg" weight="bold" color="neutral-strong">
      Cadastro e consulta grátis por 15 dias
    </FuelTypography>
    <ButtonContainer>
      <FuelButton
        variant="secondary"
        trailingIcon="comment"
        trailingIconStyle="outlined"
        size="large"
        onClick={handleClickTalkWithASpecialist}
      >
        Falar com especialista
      </FuelButton>
      <FuelButton
        variant="primary"
        trailingIcon="plus"
        trailingIconStyle="outlined"
        size="large"
        onClick={handleClickRegisterTrucker}
      >
        Cadastrar motorista
      </FuelButton>
    </ButtonContainer>
  </Container>
);
